<div class="terms-modal">
  <div class="terms-modal__header">
    <h2 mat-dialog-title>Patient Consent</h2>
    <button mat-icon-button (click)="onClose()" class="terms-modal__close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content (scroll)="onScroll($event)" class="terms-modal__content">
    <div class="terms-modal__text">
      <h3>1. Introduction</h3>
      <p>
        We value your privacy. This Privacy Policy explains how we collect, use, store, and protect your
        information when you use [App Name] ("Service").
      </p>
      <p>
        By using our Service, you agree to the practices described in this policy.
      </p>

      <h3>2. Information We Collect</h3>
      <h4>a. Information You Provide</h4>
      <p>We may collect:</p>
      <ul>
        <li>Name</li>
        <li>Email address</li>
        <li>Account login details</li>
        <li>Messages or content you submit</li>
        <li>Payment information (processed via third-party providers)</li>
      </ul>

      <h4>b. Automatically Collected Information</h4>
      <p>We may automatically collect:</p>
      <ul>
        <li>Device information (device type, OS, browser)</li>
        <li>IP address</li>
        <li>App usage data</li>
        <li>Log files and analytics data</li>
        <li>Cookies or similar technologies</li>
      </ul>

      <h4>c. Third-Party Services</h4>
      <p>
        We may use third-party services (e.g., analytics, payment processors) that collect information
        used to identify you.
      </p>

      <h3>3. How We Use Your Information</h3>
      <p>We use your information to:</p>
      <ul>
        <li>Provide and maintain our Service</li>
        <li>Notify you about changes to our Service</li>
        <li>Allow you to participate in interactive features</li>
        <li>Provide customer support</li>
        <li>Gather analysis or valuable information to improve our Service</li>
        <li>Monitor the usage of our Service</li>
        <li>Detect, prevent and address technical issues</li>
      </ul>

      <h3>4. Data Security</h3>
      <p>
        We implement appropriate security measures to protect your personal information. However, no method
        of transmission over the Internet is 100% secure.
      </p>

      <h3>5. Your Rights</h3>
      <p>You have the right to:</p>
      <ul>
        <li>Access your personal data</li>
        <li>Correct inaccurate data</li>
        <li>Request deletion of your data</li>
        <li>Object to processing of your data</li>
        <li>Request transfer of your data</li>
      </ul>
    </div>
  </mat-dialog-content>

  @if (showAcceptButton) {
    <div class="terms-modal__actions">
      <custom-button
        text="Accept"
        variant="primary"
        [disabled]="!isAcceptEnabled"
        (clicked)="onAccept()"
      />
    </div>
  }
</div>
